<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
    <button mat-icon-button disabled></button>
    <input matInput id="{{ node.id }}"
                    value="{{ node.name }}"
                    (blur)="onInputUpdate($event.target.value, node)" />
    <button mat-button type="button" (click)="onDelete(node, tree)" i18n>Delete</button>
    <button mat-button type="button" (click)="onAddSibling(node, tree)" i18n>Add Sibling</button>
    <button mat-button type="button" *ngIf="!!options.allowsHierarchy" (click)="onAddChild(node, tree)" i18n>Add Child</button>
  </mat-tree-node>
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
    <button mat-icon-button matTreeNodeToggle type="button" [attr.aria-label]="'Toggle ' + node.name">
      <mat-icon class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    <input matInput id="{{ node.id }}"
                    value="{{ node.name }}"
                    (blur)="onInputUpdate(input.value, node)" />
    <button mat-button type="button" (click)="onDelete(node, tree)" i18n>Delete</button>
    <button mat-button type="button" (click)="onAddSibling(node, tree)" i18n>Add Sibling</button>
    <button mat-button type="button" *ngIf="!!options.allowsHierarchy" (click)="onAddChild(node, tree)" i18n>Add Child</button>
  </mat-tree-node>
</mat-tree>
<div *ngIf="isEmpty()">
  No Categories - <button matButton (click)="onAddRoot()" i18n>Add Category</button>
</div>